import { render, staticRenderFns } from "./ViewAlbumContainer.vue?vue&type=template&id=79ec7054&scoped=true"
import script from "./ViewAlbumContainer.vue?vue&type=script&lang=js"
export * from "./ViewAlbumContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ec7054",
  null
  
)

export default component.exports